export default __webpack_public_path__ + "static/media/MailForm.c0ef3071.png";